// @ts-ignore
import settingsIconSvg from "remixicon/icons/System/settings-2-line.svg";
// @ts-ignore
import bookmarkIconSvg from "remixicon/icons/Business/bookmark-line.svg";
// @ts-ignore
import addIconSvg from "remixicon/icons/System/add-circle-line.svg";
// @ts-ignore
import closeIconSvg from "remixicon/icons/System/close-line.svg";
// @ts-ignore
import commentIconSvg from "remixicon/icons/Communication/chat-4-line.svg";
// @ts-ignore
import quoteIconSvg from "remixicon/icons/Communication/chat-quote-line.svg";
// @ts-ignore
import speechBubbleIconSvg from "remixicon/icons/Communication/chat-4-line.svg";
// @ts-ignore
import replyIconSvg from "remixicon/icons/Business/reply-line.svg";
// @ts-ignore
import starIconSvg from "remixicon/icons/System/star-line.svg";
// @ts-ignore
import reblogIconSvg from "remixicon/icons/Media/repeat-line.svg";
// @ts-ignore
import imageIconSvg from "remixicon/icons/Media/image-line.svg";
// @ts-ignore
import bellIconSvg from "remixicon/icons/Media/notification-line.svg";
// @ts-ignore
import checkmarkIconSvg from "remixicon/icons/System/check-line.svg";
// @ts-ignore
import githubIconSvg from "remixicon/icons/Logos/github-line.svg";
// @ts-ignore
import heartIconSvg from "remixicon/icons/Health & Medical/heart-line.svg";
// @ts-ignore
import heartFilledIconSvg from "remixicon/icons/Health & Medical/heart-fill.svg";
// @ts-ignore
import editIconSvg from "remixicon/icons/Design/edit-line.svg";
// @ts-ignore
import pencilIconSvg from "remixicon/icons/Design/pencil-line.svg";
// @ts-ignore
import deleteIconSvg from "remixicon/icons/System/delete-bin-line.svg";
// @ts-ignore
import shieldIconSvg from "remixicon/icons/System/shield-keyhole-line.svg";
// @ts-ignore
import atIconSvg from "remixicon/icons/Business/at-line.svg";
// @ts-ignore
import followIconSvg from "remixicon/icons/User & Faces/user-follow-line.svg";
// @ts-ignore
import homeIconSvg from "remixicon/icons/Buildings/home-line.svg";
// @ts-ignore
import moreIconSvg from "remixicon/icons/System/more-line.svg";
// @ts-ignore
import spinnerIconSvg from "remixicon/icons/System/loader-3-line.svg";
// @ts-ignore
import settings2IconSvg from "remixicon/icons/Media/equalizer-line.svg";
// @ts-ignore
import muteIconSvg from "remixicon/icons/Media/volume-mute-line.svg";
// @ts-ignore
import blockIconSvg from "remixicon/icons/User & Faces/user-forbid-line.svg";
// @ts-ignore
import cloudIconSvg from "remixicon/icons/Business/cloud-line.svg";
// @ts-ignore
import searchIconSvg from "remixicon/icons/System/search-line.svg";
// @ts-ignore
import arrowLeftIconSvg from "remixicon/icons/Arrows/arrow-left-s-line.svg";
// @ts-ignore
import arrowRightIconSvg from "remixicon/icons/Arrows/arrow-right-s-line.svg";
// @ts-ignore
import arrowUpIconSvg from "remixicon/icons/Arrows/arrow-up-s-line.svg";
// @ts-ignore
import arrowUpDoubleIconSvg from "remixicon/icons/Arrows/arrow-up-double-line.svg";
// @ts-ignore
import sunIconSvg from "remixicon/icons/Weather/sun-line.svg";
// @ts-ignore
import moonIconSvg from "remixicon/icons/Weather/moon-line.svg";
// @ts-ignore
import treeIconSvg from "remixicon/icons/Editor/node-tree.svg";
// @ts-ignore
import gifIconSvg from "remixicon/icons/Document/file-gif-line.svg";
// @ts-ignore
import pinIconSvg from "remixicon/icons/Map/pushpin-2-line.svg";
// @ts-ignore
import plusIconSvg from "remixicon/icons/System/add-line.svg";
// @ts-ignore
import minusIconSvg from "remixicon/icons/System/subtract-line.svg";
// @ts-ignore
import infoIconSvg from "remixicon/icons/System/information-line.svg";
// @ts-ignore
import articleIconSvg from "remixicon/icons/Document/article-line.svg";
// @ts-ignore
import downloadIconSvg from "remixicon/icons/System/download-cloud-line.svg";
// @ts-ignore
import listIconSvg from "remixicon/icons/Editor/list-unordered.svg";
// @ts-ignore
import linkIconSvg from "remixicon/icons/Editor/link.svg";
// @ts-ignore
import brushIconSvg from "remixicon/icons/Design/brush-line.svg";
// @ts-ignore
import errorIconSvg from "remixicon/icons/System/error-warning-line.svg";
// @ts-ignore
import cameraIconSvg from "remixicon/icons/Media/camera-line.svg";
// @ts-ignore
import peopleIconSvg from "remixicon/icons/User & Faces/team-line.svg";
// @ts-ignore
import hashIconSvg from "remixicon/icons/Editor/hashtag.svg";
// @ts-ignore
import upDownIconSvg from "remixicon/icons/Arrows/expand-up-down-line.svg";
// @ts-ignore
import fourKIconSvg from "remixicon/icons/Media/4k-line.svg";
// @ts-ignore
import hdIconSvg from "remixicon/icons/Media/hd-line.svg";
// @ts-ignore
import folderIconSvg from "remixicon/icons/Document/folder-line.svg";
// @ts-ignore
import playCircleIconSvg from "remixicon/icons/Media/play-circle-line.svg";
// @ts-ignore
import playIconSvg from "remixicon/icons/Media/play-line.svg";
// @ts-ignore
import eyeOpenIconSvg from "remixicon/icons/System/eye-line.svg";
// @ts-ignore
import eyeClosedIconSvg from "remixicon/icons/System/eye-off-line.svg";
// @ts-ignore
import sendIconSvg from "remixicon/icons/Business/send-plane-2-line.svg";

// @ts-ignore
import favIconSvg from "../../html/favicon.svg";

import { unsafeHTML } from "lit-html/directives/unsafe-html.js";

export const settingsIcon = unsafeHTML(settingsIconSvg);
export const settings2Icon = unsafeHTML(settings2IconSvg);
export const bookmarkIcon = unsafeHTML(bookmarkIconSvg);
export const addIcon = unsafeHTML(addIconSvg);
export const closeIcon = unsafeHTML(closeIconSvg);
export const commentIcon = unsafeHTML(commentIconSvg);
export const replyIcon = unsafeHTML(replyIconSvg);
export const starIcon = unsafeHTML(starIconSvg);
export const reblogIcon = unsafeHTML(reblogIconSvg);
export const imageIcon = unsafeHTML(imageIconSvg);
export const bellIcon = unsafeHTML(bellIconSvg);
export const checkmarkIcon = unsafeHTML(checkmarkIconSvg);
export const githubIcon = unsafeHTML(githubIconSvg);
export const heartIcon = unsafeHTML(heartIconSvg);
export const heartFilledIcon = unsafeHTML(heartFilledIconSvg);
export const editIcon = unsafeHTML(editIconSvg);
export const deleteIcon = unsafeHTML(deleteIconSvg);
export const shieldIcon = unsafeHTML(shieldIconSvg);
export const quoteIcon = unsafeHTML(quoteIconSvg);
export const atIcon = unsafeHTML(atIconSvg);
export const followIcon = unsafeHTML(followIconSvg);
export const homeIcon = unsafeHTML(homeIconSvg);
export const moreIcon = unsafeHTML(moreIconSvg);
export const spinnerIcon = unsafeHTML(spinnerIconSvg);
export const muteIcon = unsafeHTML(muteIconSvg);
export const blockIcon = unsafeHTML(blockIconSvg);
export const cloudIcon = unsafeHTML(cloudIconSvg);
export const searchIcon = unsafeHTML(searchIconSvg);
export const arrowLeftIcon = unsafeHTML(arrowLeftIconSvg);
export const arrowRightIcon = unsafeHTML(arrowRightIconSvg);
export const arrowUpIcon = unsafeHTML(arrowUpIconSvg);
export const arrowUpDoubleIcon = unsafeHTML(arrowUpDoubleIconSvg);
export const moonIcon = unsafeHTML(moonIconSvg);
export const sunIcon = unsafeHTML(sunIconSvg);
export const treeIcon = unsafeHTML(treeIconSvg);
export const gifIcon = unsafeHTML(gifIconSvg);
export const pinIcon = unsafeHTML(pinIconSvg);
export const plusIcon = unsafeHTML(plusIconSvg);
export const minusIcon = unsafeHTML(minusIconSvg);
export const infoIcon = unsafeHTML(infoIconSvg);
export const articleIcon = unsafeHTML(articleIconSvg);
export const downloadIcon = unsafeHTML(downloadIconSvg);
export const listIcon = unsafeHTML(listIconSvg);
export const linkIcon = unsafeHTML(linkIconSvg);
export const brushIcon = unsafeHTML(brushIconSvg);
export const errorIcon = unsafeHTML(errorIconSvg);
export const cameraIcon = unsafeHTML(cameraIconSvg);
export const peopleIcon = unsafeHTML(peopleIconSvg);
export const hashIcon = unsafeHTML(hashIconSvg);
export const speechBubbleIcon = unsafeHTML(speechBubbleIconSvg);
export const upDownIcon = unsafeHTML(upDownIconSvg);
export const fourKIcon = unsafeHTML(fourKIconSvg);
export const hdIcon = unsafeHTML(hdIconSvg);
export const folderIcon = unsafeHTML(folderIconSvg);
export const playCircleIcon = unsafeHTML(playCircleIconSvg);
export const playIcon = unsafeHTML(playIconSvg);
export const pencilIcon = unsafeHTML(pencilIconSvg);
export const eyeOpenIcon = unsafeHTML(eyeOpenIconSvg);
export const eyeClosedIcon = unsafeHTML(eyeClosedIconSvg);
export const favIcon = unsafeHTML(favIconSvg);
export const sendIcon = unsafeHTML(sendIconSvg);
